import { useMutation, useQueryClient } from "@tanstack/react-query";
import { vinculosApi } from "../api/vinculosApi";
import { invalidateVinculoQueries } from "./invalidateVinculoQueries";

export function useDeleteVinculoMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: vinculosApi.remove,
    onSuccess: () => {
      invalidateVinculoQueries(queryClient);
    },
  });
}
